import Video from "components/media/VideoCLD"
import FigCaption from "components/figcaption/FigCaption"

export default function VideoFigure({ fig_caption, ...props }) {
  return (
    <figure>
      <Video {...props} />
      {fig_caption?.caption?.length ? <FigCaption {...fig_caption} horizontal_position='start' /> : null}
    </figure>
  )
}
